import { App } from "vue";
import * as filestack from "filestack-js";

export const filestackPlugin =
  (apiKey: string) =>
  (app: App): void => {
    app.config.globalProperties.$filestack = filestack.init(apiKey);
  };
